/**
 * Shared formatting utilities for the ledger components
 */

/** Format currency for display (no decimals) */
export const formatCurrency = (value: string | number): string => {
  const numValue = typeof value === 'string' ? parseFloat(value) : value;
  if (Number.isNaN(numValue)) return '$0';
  return new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
  }).format(numValue);
};

/** Format currency with decimals */
export const formatCurrencyPrecise = (value: string | number): string => {
  const numValue = typeof value === 'string' ? parseFloat(value) : value;
  return new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
    minimumFractionDigits: 2,
  }).format(Number.isNaN(numValue) ? 0 : numValue);
};

/** Format compact currency (e.g., $10k) */
export const formatCompact = (value: number): string => {
  if (value >= 1000) {
    return `$${(value / 1000).toFixed(value >= 10000 ? 0 : 1)}k`;
  }
  return `$${value.toFixed(0)}`;
};

/** Parse currency string to number */
export const parseCurrency = (value: string): number => {
  const cleaned = value.replace(/[^0-9.-]/g, '');
  const num = parseFloat(cleaned);
  return Number.isNaN(num) ? 0 : num;
};

/**
 * Parse a date-only string (YYYY-MM-DD) as local time.
 *
 * `new Date("2026-03-13")` is treated as UTC midnight by the spec,
 * which shifts back a day when rendered in US timezones.
 * Appending `T00:00:00` forces local-time interpretation.
 */
export const parseDateOnly = (dateStr: string): Date =>
  new Date(`${dateStr}T00:00:00`);
